import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import tracking from 'dibs-tracking';
import PropTypes from 'prop-types';
import CartButton from './CartButton';

function CartPurchaseButton({ item, trackingLabel, quantitySelected }) {
    let href = `/checkout/id-${item.serviceId}/`;

    if (quantitySelected) {
        href = href + `?quantity=${quantitySelected}`;
    }

    return (
        <CartButton
            href={href}
            dataTn="item-actions-purchase-item"
            onClick={() => {
                tracking.trackEvent({
                    action: 'cart purchase button',
                    category: 'purchase click',
                    label: trackingLabel,
                });
                tracking.trackEcommerce({
                    type: 'addToCart',
                    products: [item.ecommerceTrackingParams],
                });
                return true;
            }}
        >
            <FormattedMessage id="CartPurchaseButton.purchase" defaultMessage="Purchase" />
        </CartButton>
    );
}

CartPurchaseButton.defaultProps = {
    quantitySelected: '1',
};

CartPurchaseButton.propTypes = {
    item: PropTypes.object.isRequired,
    trackingLabel: PropTypes.string.isRequired,
    quantitySelected: PropTypes.string,
};

export default createFragmentContainer(CartPurchaseButton, {
    item: graphql`
        fragment CartPurchaseButton_item on Item {
            serviceId
            ecommerceTrackingParams
        }
    `,
});
